import * as Info from './Info'
import * as Region from './Region'
import * as MaintenanceBreak from './maintenance-break-resource'

export default {
  Info,
  Region,
  MaintenanceBreak
}



// WEBPACK FOOTER //
// ./src/API/index.ts